import { Button, IconButton, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Close } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { allDataFilter, config_baseURL, isBaseURLAll, set_config_baseURL, set_account_override, } from '../../../api/utils';
import { AccessRoles } from '../../../constants/AccessLevel';
import useNoInitialEffect from '../../../hooks/react-mod-hooks';
import { AccountSelector } from '../../commons/AccountSelector';
import { CustomMaterialTable } from '../../commons/CustomMaterialTable';
import { SideBarComponent } from '../../commons/SideBarComponent';
import { SnackbarComponent } from '../../commons/SnackbarComponent';
import { CampaignConfigurator } from '../CampaignConfigurator';
import { Title } from '../CampaignConfigurator/CampaignConfigurator.Styles';
import { CampaignListTable } from './CampaignListTable';
import { ButtonWrapper, Content, TitleWrapper, Wrapper, } from './CampaignMainView.Styles';
// TODO: create common interface for row
export var CampaignMainView = function (_a) {
    var _b, _c, _d, _e;
    var campaigns = _a.campaigns, campaignDeps = _a.campaignDeps, campaignGroups = _a.campaignGroups, selectedAccount = _a.selectedAccount, setAccount = _a.setAccount, queues = _a.queues, contactLists = _a.contactLists, availableCallerIDs = _a.availableCallerIDs, contactFlows = _a.contactFlows, contactList = _a.contactList, accessLevel = _a.accessLevel, getCampaigns = _a.getCampaigns, getGroups = _a.getGroups, getQueues = _a.getQueues, getContactLists = _a.getContactLists, getAvailableCallerIDs = _a.getAvailableCallerIDs, getDialerDefaults = _a.getDialerDefaults, getContactFlowList = _a.getContactFlowList, deleteCampaignByID = _a.deleteCampaignByID, updateCampaignByID = _a.updateCampaignByID, addCampaign = _a.addCampaign, getOneContactList = _a.getOneContactList, tempDialerDefaults = _a.dialerDefaults, addGroup = _a.addGroup, updateGroup = _a.updateGroup, deleteGroupByID = _a.deleteGroupByID;
    var _f = useState(false), readOnly = _f[0], setReadOnly = _f[1];
    var _g = useState(false), openSidebar = _g[0], setOpenSidebar = _g[1];
    var _h = useState({}), selectedCampaign = _h[0], setSelectedCampaign = _h[1];
    var _j = useState(false), copied = _j[0], setCopied = _j[1];
    var _k = useState(false), creating = _k[0], setCreating = _k[1];
    var _l = useState(campaigns), rowData = _l[0], setRowData = _l[1];
    var _m = useState(false), openSnack = _m[0], setOpenSnack = _m[1];
    var _o = useState(''), snackMessage = _o[0], setSnackMessage = _o[1];
    var _p = useState(false), openAlert = _p[0], setOpenAlert = _p[1];
    var _q = useState(false), openDependencyList = _q[0], setOpenDependencyList = _q[1];
    var _r = useState(false), openGroupDependencyList = _r[0], setOpenGroupDependencyList = _r[1];
    var _s = useState(''), groupDependencyTitle = _s[0], setGroupDependencyTitle = _s[1];
    var _t = useState({
        cascadeDeletable: true,
        dependents: {
            scheduleExecutions: [],
            schedules: []
        }
    }), dependents = _t[0], setDependents = _t[1];
    var _u = useState([]), groupDependents = _u[0], setGroupDependents = _u[1];
    var _v = useState(''), dataId = _v[0], setDataId = _v[1];
    var _w = useState('success'), severity = _w[0], setSeverity = _w[1];
    var _x = useState(tempDialerDefaults), dialerDefaults = _x[0], setGlobalDefaults = _x[1];
    var _y = useState(config_baseURL()), accountURL = _y[0], setAccountURL = _y[1];
    useEffect(function () {
        if (Array.isArray(tempDialerDefaults)) {
            var temp = tempDialerDefaults.find(function (tg) { return tg.prjacc.url === config_baseURL(); });
            setGlobalDefaults(temp);
        }
        else {
            setGlobalDefaults(tempDialerDefaults);
        }
    }, [accountURL, tempDialerDefaults]);
    useNoInitialEffect(function () {
        set_account_override('1');
        if (!isBaseURLAll()) {
            getQueues();
            getContactLists();
            getAvailableCallerIDs();
            getContactFlowList();
            getDialerDefaults();
            getGroups();
        }
        return function () { return set_account_override('0'); };
    }, [accountURL]);
    var handleOnRowDoubleClick = function (row, isEdit) {
        handleOpenSideBar();
        if (!isEdit) {
            setCopied(true);
            setCreating(true);
        }
        else if (isEdit) {
            setCreating(false);
            setCopied(false);
        }
        setSelectedCampaign(row);
    };
    var handleDeleteClick = function (id, cascade) {
        deleteCampaignByID(id, cascade, function (data) {
            handleDeleteCallback(data);
        });
    };
    var handleOpenSideBar = function (readOnly) {
        setOpenSidebar(true);
        if (!readOnly &&
            accessLevel !== AccessRoles.READ_ONLY &&
            accessLevel !== AccessRoles.ANALYST)
            localStorage.setItem('onEditMode', '1');
    };
    var handleOpenSnack = function () {
        setOpenSnack(true);
    };
    var handleCloseSnack = function (_event, reason) {
        setOpenSnack(false);
    };
    useEffect(function () {
        getCampaigns();
        getQueues();
        getContactLists();
        getAvailableCallerIDs();
        getContactFlowList();
        getDialerDefaults();
        getGroups();
    }, [selectedAccount]);
    useEffect(function () {
        setRowData(campaigns);
    }, [campaigns]);
    var handleUpdateCallback = function (data) {
        var status = data.action.type;
        if (status === 'UPDATE_CAMPAIGN_FULFILLED') {
            setSnackMessage('Campaign Updated!');
            setSeverity('success');
        }
        else if (data.errorMessage && data.errorMessage.includes('409')) {
            setSnackMessage('Data state is stale; refresh & retry!');
            setSeverity('error');
        }
        else {
            setSnackMessage('Campaign Update Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleAddCallback = function (data) {
        var status = data.action.type;
        if (status === 'ADD_CAMPAIGN_FULFILLED') {
            setSnackMessage('Campaign Created!');
            setSeverity('success');
        }
        else {
            setSnackMessage('Campaign Creation Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleDeleteCallback = function (data) {
        var _a;
        var status = data.action.type;
        var response = data === null || data === void 0 ? void 0 : data.response;
        if (status === 'DELETE_CAMPAIGN_FULFILLED') {
            setSnackMessage('Campaign Deleted!');
            setSeverity('success');
            setOpenSnack(true);
            setOpenDependencyList(false);
        }
        else if ((response === null || response === void 0 ? void 0 : response.status) !== 409) {
            setSnackMessage('Campaign Deletion Failed!');
            setSeverity('error');
            setOpenSnack(true);
        }
        else {
            setDependents((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.dependents);
            setOpenDependencyList(true);
        }
    };
    var handleDiscard = function () {
        setOpenSidebar(false);
        setReadOnly(false);
        setSelectedCampaign({});
        localStorage.setItem('onEditMode', '0');
    };
    var alertReadOnly = function () {
        setSnackMessage('Access Denied');
        setSeverity('info');
        setOpenSnack(true);
    };
    var handleClose = function () {
        setOpenAlert(false);
    };
    var onHandleCopyToClipboard = function () {
        navigator.clipboard.writeText(JSON.stringify(dependents));
        setSnackMessage('Copied to Clipboard');
        setSeverity('success');
        setOpenSnack(true);
    };
    var onHandleGroupCopyToClipboard = function () {
        navigator.clipboard.writeText(JSON.stringify(groupDependents));
        setSnackMessage('Copied to Clipboard');
        setSeverity('success');
        setOpenSnack(true);
    };
    var handleAddGroupCallback = function (data) {
        var status = data.action.type;
        if (status === 'ADD_GROUP_FULFILLED') {
            setSnackMessage('Group Created!');
            setSeverity('success');
        }
        else {
            setSnackMessage('Group Creation Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleUpdateGroupCallback = function (data) {
        var status = data.action.type;
        if (status === 'UPDATE_GROUP_FULFILLED') {
            setSnackMessage('Group Updated!');
            setSeverity('success');
        }
        else if (data.errorMessage && data.errorMessage.includes('409')) {
            setSnackMessage('Data state is stale; refresh & retry!');
            setSeverity('error');
        }
        else {
            setSnackMessage('Group Update Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleGroupDeleteCallback = function (data) {
        var _a;
        var status = data.action.type;
        var response = data === null || data === void 0 ? void 0 : data.response;
        var groupName = (_a = campaignGroups.find(function (row) { return row.id === (response === null || response === void 0 ? void 0 : response.id); })) === null || _a === void 0 ? void 0 : _a.name;
        if (status === 'DELETE_GROUP_FULFILLED') {
            setSnackMessage('Group Deleted!');
            setSeverity('success');
            setOpenSnack(true);
            setOpenGroupDependencyList(false);
        }
        else if ((response === null || response === void 0 ? void 0 : response.status) !== 409) {
            setSnackMessage('Group Deletion Failed!');
            setSeverity('error');
            setOpenSnack(true);
        }
        else {
            setGroupDependents(response === null || response === void 0 ? void 0 : response.data.dependents.dependents.campaigns);
            setGroupDependencyTitle(groupName || '');
            setOpenGroupDependencyList(true);
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(Title, { variant: 'h6' }, "Campaigns"),
            React.createElement(ButtonWrapper, null,
                React.createElement(AccountSelector, { initialValue: selectedAccount, onValueChange: function (data) { return setAccount(data); }, disabled: openSidebar }),
                React.createElement(Button, { variant: 'contained', disabled: openSidebar, color: 'primary', onClick: function () {
                        setCreating(true);
                        setSelectedCampaign({});
                        handleOpenSideBar();
                    } }, accessLevel === AccessRoles.ANALYST ||
                    accessLevel === AccessRoles.READ_ONLY
                    ? 'See Form'
                    : 'New Campaign'))),
        React.createElement(SideBarComponent, { topOffSet: 47, open: openSidebar, readonly: readOnly ||
                accessLevel === AccessRoles.READ_ONLY ||
                accessLevel === AccessRoles.ANALYST, component: React.createElement(CampaignConfigurator, { readOnly: readOnly ||
                    accessLevel === AccessRoles.READ_ONLY ||
                    accessLevel === AccessRoles.ANALYST, onDiscardClick: function () { return handleDiscard(); }, campaigns: campaigns, title: selectedCampaign.name, creating: creating, copied: copied, groups: allDataFilter(campaignGroups), queues: allDataFilter(queues), contactLists: allDataFilter(contactLists), availableCallerIDs: allDataFilter(availableCallerIDs), contactFlows: allDataFilter(contactFlows), contactList: contactList, getOneContactList: getOneContactList, dialerDefaults: dialerDefaults, accessLevel: accessLevel, selectedRow: selectedCampaign, updateCampaignByID: function (editedCampaignConfig, id, initialCampaignConfig) {
                    return updateCampaignByID(editedCampaignConfig, id, function (data) {
                        handleUpdateCallback(data);
                    }, initialCampaignConfig);
                }, addCampaign: function (campaign) {
                    return addCampaign(campaign, function (data) {
                        handleAddCallback(data);
                    });
                }, onAddGroup: function (group) {
                    addGroup(group, function (data) {
                        handleAddGroupCallback(data);
                    });
                }, onEditGroup: function (group, id, initialGroup) {
                    updateGroup(group, id, function (data) {
                        handleUpdateGroupCallback(data);
                    }, initialGroup);
                }, onDeleteGroup: function (id) {
                    deleteGroupByID(id, function (data) {
                        handleGroupDeleteCallback(data);
                    });
                }, handleOpenSnack: handleOpenSnack, onAlert: function (data, severity) {
                    setSnackMessage(data);
                    setSeverity(severity);
                    setOpenSnack(true);
                }, onAccountChange: function (url) { return setAccountURL(url); } }) },
            React.createElement(Content, null,
                React.createElement(CampaignListTable, { onRowDoubleClick: function (_row, isEdit) {
                        if (accessLevel === AccessRoles.READ_ONLY ||
                            accessLevel === AccessRoles.ANALYST) {
                            alertReadOnly();
                        }
                        else {
                            handleOnRowDoubleClick(_row, isEdit);
                        }
                    }, viewRow: function (_row) {
                        setReadOnly(true);
                        handleOpenSideBar(true);
                        setSelectedCampaign(_row);
                    }, deleteRow: function (_id) {
                        if (accessLevel === AccessRoles.READ_ONLY ||
                            accessLevel === AccessRoles.ANALYST) {
                            alertReadOnly();
                        }
                        else {
                            setOpenAlert(true);
                            setDataId(_id);
                            var aCampaign = campaigns.find(function (c) { return c.id === _id; });
                            if (isBaseURLAll() && (aCampaign === null || aCampaign === void 0 ? void 0 : aCampaign.prjacc)) {
                                set_config_baseURL(aCampaign.prjacc.url);
                            }
                        }
                    }, rowData: rowData, openSidebar: openSidebar, campaigns: campaigns })),
            React.createElement(SnackbarComponent, { anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }, open: openSnack, autoHideDuration: 5000, onAlertClose: handleCloseSnack, alertMessage: snackMessage, severity: severity })),
        React.createElement(Dialog, { open: openAlert, onClose: function () { return handleClose(); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, "Delete Campaign"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Are you sure you want to delete this campaign?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return handleClose(); }, color: 'primary' }, "Disagree"),
                React.createElement(Button, { onClick: function () {
                        handleClose();
                        handleDeleteClick(dataId, false);
                    }, color: 'primary', autoFocus: true }, "Agree"))),
        React.createElement(Dialog, { open: openDependencyList, onClose: function () { return setOpenDependencyList(false); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { disableTypography: true, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingRight: 5
                } },
                React.createElement(Typography, { variant: 'h6' }, "Dependents"),
                React.createElement(IconButton, { "aria-label": 'close', onClick: function () { return setOpenDependencyList(false); } },
                    React.createElement(Close, null))),
            React.createElement(DialogContent, { dividers: true },
                React.createElement(DialogContentText, { id: 'alert-dialog-description' },
                    React.createElement(CustomMaterialTable, { rows: (_c = (_b = dependents === null || dependents === void 0 ? void 0 : dependents.dependents) === null || _b === void 0 ? void 0 : _b.schedules) === null || _c === void 0 ? void 0 : _c.concat((_e = (_d = dependents === null || dependents === void 0 ? void 0 : dependents.dependents) === null || _d === void 0 ? void 0 : _d.scheduleExecutions) === null || _e === void 0 ? void 0 : _e.map(function (s) { return ({
                            scheduleId: "[Execution] " + s.id,
                            scheduleName: 'n/a'
                        }); })), columns: [
                            { label: 'Schedule ID', value: 'scheduleId' },
                            { label: 'Schedule Name', value: 'scheduleName' },
                        ] }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return onHandleCopyToClipboard(); }, color: 'primary' }, "Copy To Clipboard"),
                React.createElement(Button, { disabled: !dependents.cascadeDeletable, onClick: function () {
                        handleClose();
                        handleDeleteClick(dataId, true);
                    }, color: 'primary', autoFocus: true }, "Proceed Deletion"))),
        React.createElement(Dialog, { open: openGroupDependencyList, onClose: function () { return setOpenGroupDependencyList(false); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { disableTypography: true, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingRight: 5
                } },
                React.createElement(Typography, { variant: 'h6' },
                    "Dependents: [",
                    groupDependencyTitle,
                    "]"),
                React.createElement(IconButton, { "aria-label": 'close', onClick: function () { return setOpenGroupDependencyList(false); } },
                    React.createElement(Close, null))),
            React.createElement(DialogContent, { dividers: true },
                React.createElement(DialogContentText, { id: 'alert-dialog-description' },
                    React.createElement(CustomMaterialTable, { rows: groupDependents, columns: [
                            { label: 'Campaign Name', value: 'campaignName' },
                            { label: 'Campaign ID', value: 'campaignId' },
                        ] }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return onHandleGroupCopyToClipboard(); }, color: 'primary' }, "Copy To Clipboard")))));
};
CampaignMainView.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CampaignMainView.js.map